import React from "react";
import { useParams } from "react-router-dom";
import MentorshipThanksWrapperArea from "./MentorshipThanksWrapperArea";

function MentorshipThanks() {

  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <MentorshipThanksWrapperArea hash={hash} />
    </>
  );
}

export default MentorshipThanks;
